module.exports = __webpack_public_path__ + "img/business-phone.688c8e57.png";